import { Modal } from "antd";
import styles from "./styles.module.scss";

import { Tabs } from "antd";
import { PurchaseTab } from "./PurchaseTab";
import { ShipmentTab } from "./ShipmentTab";

interface ManageDataEntriesModalProps {
  open: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const ManageDataEntriesModal: React.FC<ManageDataEntriesModalProps> = ({
  open,
  onCancel,
  onSave,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      className={styles.modal}
      centered
      closable
      width={1000}
    >
      <div className={styles.modalContainer}>
        <h2 className={styles.title}>Manage Data Entries</h2>

        <Tabs
          defaultActiveKey="1"
          centered
          size="large"
          className={styles.tabs}
          items={[
            {
              label: `Purchase orders`,
              key: "1",
              children: <PurchaseTab />,
            },
            {
              label: `Shipment orders`,
              key: "2",
              children: <ShipmentTab />,
            },
          ]}
        />

        <div className={styles.bottomActions}>
          <button onClick={onCancel} className={styles.cancelButton}>
            Cancel
          </button>
          <button onClick={onSave} className={styles.blueButton}>
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ManageDataEntriesModal;
